import { TextField } from "@mui/material";
import { formatWithTwoDecimals } from "../utilities/helper";

const ColumnAmount = ({ params, item }) => {
  // Use backend field name from _fieldIds mapping if available, otherwise fall back to sName
  const fieldId = params?.row?._fieldIds?.[item?.sColumnID] || item?.inputType?.component?.sName;

  return (
    <TextField
      type="text"
      inputMode="numeric"
      placeholder={item?.inputType?.component?.sPlaceHolder}
      id={`${fieldId}-${params?.row?.id}`}
      InputProps={{
        style: { textAlign: item?.inputType?.component?.sJustify },
        inputProps: { style: { MozAppearance: "textfield" } },
      }}
      sx={{
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
          {
            WebkitAppearance: "none",
            margin: 0,
          },
        "& input": {
          textAlign: "right",
          MozAppearance: "textfield",
        },
      }}
      disabled={item?.bEditable === 0 ? true : false}
      value={params?.row?.[item?.sColumnID] ?? formatWithTwoDecimals(Number(item?.inputType?.component?.sDefaultValue))}
    />
  );
};

export default ColumnAmount;
